<div class="ib">
  <button
    *ngIf="hasPromise"
    df-button
    [dfButtonType]="buttonType"
    [type]="'button'"
    class="btn guts-p-h-1 guts-m-r-half follow-button"
    (click)="onClick({ isActive: isActive, event: $event })"
    (focus)="onFocus()"
    (mouseover)="onFocus()"
    (mouseleave)="onBlur()"
    (blur)="onBlur()"
    [attr.aria-pressed]="ariaPressed"
    data-dgat="iconButton-4bf"
    [attr.aria-label]="buttonLabel + a11yContext ? ': ' + a11yContext : ''"
    [ngClass]="!isActive ? buttonClasses : ''"
  >
    <df-spinner-button [isSpinning]="submitting"></df-spinner-button>
    <span
      *ngIf="!submitting"
      class="btn__icon"
      [ngClass]="{
        'on-hover': isHover && isActive,
        'off-hover': !isHover && isActive
      }"
    >
      <df-icon [icon]="icon"></df-icon>
      {{ buttonLabel }}
    </span>
  </button>
  <button
    *ngIf="!hasPromise"
    df-button
    [dfButtonType]="buttonType"
    [type]="'button'"
    class="btn profile-button guts-p-h-1 follow-button"
    (click)="onClick({ isActive: isActive, event: $event })"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (mouseover)="onFocus()"
    (mouseleave)="onBlur()"
    [attr.aria-pressed]="ariaPressed"
    data-dgat="iconButton-f33"
    [attr.aria-label]="buttonLabel + a11yContext ? ': ' + a11yContext : ''"
    [ngClass]="!isActive ? buttonClasses : ''"
  >
    <span
      *ngIf="!submitting"
      class="btn__icon"
      [ngClass]="{
        'on-hover': isHover && isActive,
        'off-hover': !isHover && isActive
      }"
    ></span>
    <df-icon [icon]="icon"></df-icon>
    {{ buttonLabel }}
  </button>
</div>
